export default "__VITE_ASSET__CqwenGb___"